import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { CallCenterSearchModel } from "src/app/model/CallCenterSearchModel";
import { Page } from "src/app/model/Page";
import { CallCenterService } from "src/app/services/call-center.service";

@Component({
  selector: "app-secure-call-center-search",
  templateUrl: "./call-center-search.component.html",
  styleUrls: ["./call-center-search.component.scss"],
})
export class CallCenterSearchComponent implements OnInit {
  page: Page<CallCenterSearchModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  isLoading: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<CallCenterSearchModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicantName",
    "panNumber",
    "maskedAadhaarNumber",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private callCenterService: CallCenterService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.page = null;
    this.dataSource = new MatTableDataSource();
    this.currentPage = 0;
    this.paginator.pageIndex = this.currentPage;
    this.paginator.length = 0;
  }

  onLoad() {
    this.isLoading = true;
    this.callCenterService.fetchFilterList(this.currentPage, this.pageSize, 
      this.filterForm.value.filterText).subscribe((page) => {
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
      this.isLoading = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onLoad();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Search", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

}